import React, { useEffect, useId, useRef } from 'react';
import { X } from 'lucide-react';
export default function Modal({ open, onClose, title, children, testId }) {
  const panel = useRef(null);
  const closeRef = useRef(onClose); closeRef.current = onClose;
  const titleId = useId();
  useEffect(() => {
    if (!open) return undefined;
    const previous = document.activeElement;
    const overflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    panel.current?.focus();
    const keys = event => {
      if (event.key === 'Escape') { event.preventDefault(); closeRef.current(); }
      if (event.key === 'Tab') {
        const nodes = [...panel.current.querySelectorAll('button:not([disabled]), a[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex="0"]')];
        const first = nodes[0], last = nodes[nodes.length - 1];
        if (!first) { event.preventDefault(); panel.current.focus(); }
        else if (event.shiftKey && (document.activeElement === first || document.activeElement === panel.current)) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      }
    };
    document.addEventListener('keydown', keys);
    return () => { document.removeEventListener('keydown', keys); document.body.style.overflow = overflow; if (previous?.isConnected) previous.focus(); };
  }, [open]);
  if (!open) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-3 sm:p-4 admin-modal-shell" data-testid={testId}>
    <div className="absolute inset-0 bg-black/40" onClick={onClose} aria-hidden="true" />
    <div ref={panel} role="dialog" aria-modal="true" aria-labelledby={titleId} tabIndex={-1} className="relative bg-white border border-border rounded-2xl w-full min-w-0 max-w-2xl max-h-[90dvh] overflow-y-auto admin-modal-panel">
      <div className="flex items-center justify-between gap-3 p-4 sm:p-6 border-b border-border sticky top-0 bg-white z-10">
        <h2 id={titleId} className="text-lg sm:text-xl font-semibold min-w-0 break-words" data-testid={`${testId}-title`}>{title}</h2>
        <button type="button" onClick={onClose} aria-label="Pencereyi kapat" className="icon-button" data-testid={`${testId}-close-button`}><X size={20} /></button>
      </div><div className="p-4 sm:p-6 admin-modal-content">{children}</div>
    </div>
  </div>;
}
